module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAWlBMVEX4+v0AAAD4+v34+v34+v38/f7////////////6/P7////////////////////+///+///+/v/+/v/9/v78/f77/P76+/3////////////+/v/+/v/+/v/////wLudgAAAAHXRSTlMZAA4IEy/ateAk+vLDopmQiHFpTjcpH+XNp19/d3h2abwAAADYSURBVCjPhZNZDsMgDESnQKDZmn1tuf81m8ZAKCji/UTiaWwptvFwcCZwIBi/3pxm8GCB5gjgvmaIYJcWQIwg7WXjPFzfGH5q3HI4Kn1XHmF4V1Uz5cNMcZjOr4a+nT5Y5Cun7jC1K938AlOpT+qMqkOYtNayyzCSlWStBMbleC2VKk6tEPB+ao861K326RGyebag1n73zKu+XZJZLZ0tR6sZ3EDy1ub3ayjmp8450JMuOjjsSKbPqolq+B8JxbO+XqVULUlDYh0Sy5RYxcQiJ84geUSJE/wCtFEQw2znHjMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f3.png
// module id = 884
// module chunks = 1